/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSubheaderBar = {
  init: function($section){

    // Add settings from schema to current object
    window.PXUTheme.jsSubheaderBar = $.extend(this, window.PXUTheme.getSectionData($section));

    this.element = $section[0];
    this.delegateElement = new domDelegate.Delegate(this.element);

    this.$el = $("#SubheaderBar");
    this.attachListeners();
  },
  attachListeners: function() {
    this.delegateElement.on('click', '[data-klaviyo-popup="open"]', this.openKlaviyoPopup.bind(this));
    this.delegateElement.on('click', '[data-bar-link]', this.barRedirect.bind(this));
  },
  barRedirect() {
    window.location = this.bar_link;
  },
  disableSticky: function() {
    // Remove sticky functionality and recalculate offset for header sticky
    this.$el.unstick();
  },
  unload: function($section) {
    $('#SubheaderBar').off();
    $('#SubheaderBar').unstick();
  },
  openKlaviyoPopup: function(argument) {
    eval(this.klaviyo_code);
  }
}

/******/ })()
;